import { createFeatureSelector, createSelector } from '@ngrx/store';

import { OrderConfirmationState } from './order-confirmation.state';

export const selector = createFeatureSelector<OrderConfirmationState>('orderConfirmation');
export const selectId = createSelector(selector, (state) => state?.id);
export const selectConfirmation = createSelector(selector, (state) => state?.confirmation);
export const selectEmail = createSelector(selector, (state) => state?.email);
export const selectAddress = createSelector(selector, (state) => state?.address);
export const selectOrder = createSelector(selector, (state) => state?.order);
export const selectTotalOrder = createSelector(selector, (state) => state?.order?.totalOrder);
export const selectPresale = createSelector(selector, (state) => state?.presale);
export const selectDeliveryDate = createSelector(selector, (state) => state?.deliveryDate);
export const selectDeliveryDates = createSelector(selector, (state) => state?.deliveryDates);
export const selectIsSuborder = createSelector(selector, (state) => state?.confirmation?.suborders?.length > 1);
export const selectSuborders = createSelector(selector, (state) => state?.confirmation?.suborders);
export const selectShippingMethod = createSelector(selector, (state) => state?.confirmation?.shippingMethod?.name);
export const selectShippingMethodKind = createSelector(selector, (state) => state?.confirmation?.shippingMethod?.kind);
export const selectPaymentMethodData = createSelector(selector, (state) => state?.confirmation?.payment?.firstPaymentData);
export const selectPaymentMethodKind = createSelector(selector, (state) => state?.confirmation?.payment?.firstMethod?.kind);
export const selectWalletInfo = createSelector(selector, (state) => state?.wallet);
export const selectHideWallet = createSelector(selector, (state) => state?.hideWallet);
export const selectOrderItems = createSelector(selector, (state) => state?.confirmation?.items);
export const selectOrderId = createSelector(selector, (state) => state?.confirmation?.id);
